/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "COMMENT_SEEN" | "CONFIGURE_PUBLIC_PROFILE_URL" | "DEFAULT_QA_STORY_MODE" | "DISABLE_LIVE_UPDATES" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "EMAIL_META" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "VIEWER_COUNT" | "Z_KEY" | "%future added value";
export type TabBarContainer_settings = {
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly " $refType": "TabBarContainer_settings";
};
export type TabBarContainer_settings$data = TabBarContainer_settings;
export type TabBarContainer_settings$key = {
    readonly " $data"?: TabBarContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBarContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBarContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '02d9bf6e3e3d127d0e14b60f874fc7c9';
export default node;
